import React from 'react';
import ChanelFooter from 'components/chanel/ChanelFooter/ChanelFooter';
import usePageContext from 'hooks/user/usePageContext';

/* This method is only called is brandContext IS Chanel - a temp. performance optimization prior to SPA */
export default function BrandFooter() {
    const pageContext = usePageContext();
    const isChanel = pageContext?.brandContext === 'chanel';

    if (isChanel) {
        return <ChanelFooter />;
    }

    return null;
}
